import React, { Component } from 'react';
import EtelAPI from '../api/EtelAPI';

import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from './Dialog';

class BatchDeleteDialog extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      from: this.props.from === undefined ? '' : this.props.from,
      show: this.props.show === undefined ? false : this.props.show,
      endpoint: this.props.endpoint === undefined ? '' : this.props.endpoint,
      searchfilter: this.props.searchfilter === undefined ? {} : this.props.searchfilter,
      loadOnCreation: this.props.loadOnCreation === undefined ? false : this.props.loadOnCreation,
      count: 0,
      isdeleting: false,
    };
    this.onHandleClose = this.onHandleClose.bind( this );
    this.onHandleConfirm = this.onHandleConfirm.bind( this );
  }

  componentDidMount(){
    const load = this.state.loadOnCreation;
    const searchfilter = this.state.searchfilter;
    if( load === true && Object.keys( searchfilter ).length !== 0 ){
      this.getBatchCount( searchfilter ).then( ( TOTAL_COUNT ) => {
        this.setState( {
          count: TOTAL_COUNT
        } );
      } ).catch( ( exception ) => {
        this.setState( {
          count: 0
        } );
      } );
    }
  }

  componentWillReceiveProps( nextProps ) {
    this.getBatchCount( nextProps.searchfilter ).then( ( TOTAL_COUNT ) => {
      this.setState( {
        from: nextProps.from === undefined ? '' : nextProps.from,
        show: nextProps.show === undefined ? false : nextProps.show,
        endpoint: nextProps.endpoint === undefined ? '' : nextProps.endpoint,
        searchfilter: nextProps.searchfilter === undefined ? {} : nextProps.searchfilter,
        count: TOTAL_COUNT
      } );
    } ).catch( ( exception ) => {
      this.setState( {
        from: nextProps.from === undefined ? '' : nextProps.from,
        show: nextProps.show === undefined ? false : nextProps.show,
        endpoint: nextProps.endpoint === undefined ? '' : nextProps.endpoint,
        count: 0
      } );
    } );
  }

  onHandleClose( e ) {
    if( this.props.onClose !== undefined ){
      this.props.onClose( e );
    }
  }

  onHandleConfirm( e ) {
    this.setState( {
      isdeleting: true
    } );
    this.deleteBatch( this.state.searchfilter ).then( ( result ) => {
      if( this.props.onBatchDeleteConfirm !== undefined ) {
        this.props.onBatchDeleteConfirm( e );
      }
      this.setState( {
        deleting: false,
        show: false
      } );
    } ).catch( ( exception ) => {
      if( this.props.onDeleteBatchError !== undefined ) {
        this.props.onDeleteBatchError( exception );
      }
    } );
  }

  getBatchCount( searchfilter ) {
    const endpoint = this.state.endpoint + '/batch/count';
    const api = new EtelAPI( endpoint );
    const getParameters = () => {
      const keys = Object.keys( searchfilter );
      let parameters = [];
      if( keys !== undefined ) {
        if( keys.length > 0 ) {
          for( var index = 0; index < keys.length; index++ ) {
            const key = keys[ index ];
            const parameter = {};
            const value = searchfilter[ key ];
            if( value !== '' && value !== undefined && value !== null ) {
              parameter[ key ] = value;
              parameters.push( parameter );
            }
          }
        }
      }
      return parameters;    
    };

    return new Promise( function( resolve, reject ) {
      let parameters = getParameters();
      if( parameters.length > 0 ) {
        api.get( parameters ).then( ( result ) => {
          if( result !== undefined ) {
            if( result.length > 0 ) {
              resolve( result[0].TOTAL_COUNT );
            } else {
              resolve( 0 );
            }
          } else {
            resolve( 0 );
          }
          resolve( result );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      } else {
        resolve( 0 );
      }
    } );
  }

  deleteBatch( searchfilter ) {
    const endpoint = this.state.endpoint + '/batch';
    const api = new EtelAPI( endpoint );
    const getParameters = () => {
      const keys = Object.keys( searchfilter );
      let parameters = [];
      if( keys !== undefined ) {
        if( keys.length > 0 ) {
          for( var index = 0; index < keys.length; index++ ) {
            const key = keys[ index ];
            const parameter = {};
            const value = searchfilter[ key ];
            if( value !== '' && value !== undefined && value !== null ) {
              parameter[ key ] = value.toString();
              parameters.push( parameter );
            }
          }
        }
      }
      return parameters;    
    };

    return new Promise( function ( resolve, reject ) {
      let parameters = getParameters();
      if( parameters.length > 0 ) {
        api.deletemany( parameters ).then( ( result ) => {
          resolve( result );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      } else {
        resolve( [] );
      }
    } );
  }

  render() {
    const caption = 'Delete ' + this.state.from + ' record(s)';
    let message = 'There are no records to delete.';
    if( this.state.isdeleting === false ) {
      if( this.state.count > 0 ) {
        if( this.state.count === 1 ) {
          message = 'Are you sure you want to delete ' + this.state.count + ' record?';
        } else {
          message = 'Are you sure you want to delete ' + this.state.count + ' records?';
        }
      } 
    } else {
      message = 'Please wait deleting records...';
    }
    return (
      <Dialog show={this.state.show} width={20} height={20} >
        <DialogHeader caption={caption} closeButton onClose={this.onHandleClose} />
        <DialogBody>
          <span className="batch-delete-dialog-body">
            {message}
          </span>
        </DialogBody>
        <DialogFooter>
          <span className="batch-delete-dialog-footer">
            <button className="batch-delete-dialog-cancel-button" onClick={this.onHandleClose}>Cancel</button>
            <button className="batch-delete-dialog-confirm-button" onClick={this.onHandleConfirm}>Confirm</button>
          </span>
        </DialogFooter>
      </Dialog>    
    );
  }
}

export default BatchDeleteDialog;


// WEBPACK FOOTER //
// ./src/presentation/BatchDeleteDialog.js